import historyTabTemplate from '@/audit/layout/historyTabTemplate';

export default historyTabTemplate(['requests'], ({ requests }) => requests.audit, 'request');
